// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"9756eeea","186":"fab5b596","225":"68401b98","264":"35f5d586","285":"c5a5cc86","355":"0d3a3eca","470":"6adb9d07","508":"7e1c9b47","552":"7092f317","724":"008c30fd","780":"0ce00097","954":"68385fa3"}[chunkId] + ".chunk.js";
};